import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export const Spinner = () => {
  return (
    <div className="gpc__loading-screen">
      <ClipLoader size={30} />
    </div>
  );
};

export default Spinner;
